import { render, staticRenderFns } from "./BuildinLayoutTopLeftDouble.vue?vue&type=template&id=4cda595d&scoped=true&"
import script from "./BuildinLayoutTopLeftDouble.vue?vue&type=script&lang=ts&"
export * from "./BuildinLayoutTopLeftDouble.vue?vue&type=script&lang=ts&"
import style0 from "./BuildinLayoutTopLeftDouble.vue?vue&type=style&index=0&id=4cda595d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cda595d",
  null
  
)

export default component.exports